import { get } from "../Services/http";
import { translate } from "../Services/translation";

export async function initExpressCheckoutFromCart(): Promise<string> {
    try {
        const response = await get(`/api/vipps/cart`);
        var result = await response.text();
        window.location.replace(result);
    } catch (error) {
        return translate('expresscheckout.general.error');
    }

    return '';
}

export async function initExpressCheckoutFromProduct(articleNumber: string, quantity: number): Promise<string> {
    try {
        await get(`/api/vipps/isInStock?articleNumber=${articleNumber}&quantity=${quantity}`);
    } catch (error) {
        return translate('stock.not.enough');
    }

    try {
        const response = await get(`/api/vipps?articleNumber=${articleNumber}&quantity=${quantity}`);
        var result = await response.text();
        window.location.replace(result);
    } catch (error) {
        return translate('expresscheckout.general.error');
    }

    return '';
}